import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core'

@Component({
  selector: 'dmmp-website-related-content-tags',
  templateUrl: './website-related-content-tags.component.html',
})
export class WebsiteRelatedContentTagsComponent implements OnInit {
  @Input() module
  @Input() identifier
  @Output() page = new EventEmitter()
  @Output() anchorCustom = new EventEmitter()
  constructor() {}

  ngOnInit() {}
}
